import { EntityTypeEnum } from './entity';
import { WorkpaperRoleEnum } from './workpaper';
import { UserOverview } from './user';
import { Note } from './note';

export enum WorkpaperProcedureStatusEnum {
    ACTIVE = 'ACTIVE',
    CHECKED = 'CHECKED',
    NOT_APPLICABLE = 'NOT_APPLICABLE',
}

export type WorkpaperProcedure = {
    id: string;
    workpaperId: string;
    procedureId: string;
    workpaperProcedureCategory?: { id: string; name: string } | null;
    reference: string;
    sequence: number;
    system: boolean;
    name: string;
    description?: string;
    role: WorkpaperRoleEnum;
    entityType?: EntityTypeEnum | null;
    createdAt: Date;
    updatedAt: Date;
    status: WorkpaperProcedureStatusEnum;
    userAction?: UserOverview & { date: Date };
    notApplicableReason?: string;
    notes: Note[];
};

export type WorkpaperProcedureResult = {
    procedure: WorkpaperProcedure;
    category?: { id: string; name: string } | null;
};

export type ProcedureStatistics = {
    active: number;
    checked: number;
    notApplicable: number;
};

export type WorkpaperProcedureCategory = {
    id: string | null;
    workpaperId: string;
    categoryId: string | null;
    reference: string | null;
    name: string | null;
    createdAt?: Date;
    updatedAt?: Date;
    totalProcedureCount: number;
    completedProcedureCount: number;
};

export type WorkpaperProceduresGroup = {
    categoryId?: string;
    categoryName: string;
    procedures: WorkpaperProcedure[];
    isCollapsed: boolean;
    totalProcedureCount: number;
    completedProcedureCount: number;
};
